export const COLORS = {
  BLACK_TITLE: '#191B1D',
  BLACK_SUBTITLE: '#191B1D',
  ROUTE_PATH: '#777777',
  INDUSTRY_BORDER: '#E8E8E8',
  GRAY_TEXT: '#999999',
  MODAL_DESCRIPTION_TEXT: '#5D5D5D',
  INDUSTRY_INACTIVE_TEXT: '#777777',
  WHITE: '#FFF',
  BLACK: '#000000',
  MAIN_RED: '#C63031',
  MAIN_RED_OPACITY: '#c6303088',
  RED_HOVER: '#D13B3B',
  PRODUCTS_ARROW: '#C63031',
  HEADER_BACKGROUND: '#9A9797FF',
  HEADER_HOME_BACKGROUND:
    'linear-gradient(180deg, #2F234C 10.17%, #A32933 56.05%, #2F234C 101.92%)',
  HEADER_PORTFOLIO_BACKGROUND:
    'linear-gradient(270deg, #292238 16.1%, #900B17 55.6%, #2F234C 100%)',
  CTA_BACKGROUND: '#2E2E2E',
  PORTFOLIO_BACKGROUND: '#F1F1F1',
  FOOTER_BACKGROUND: '#2E2E2E',
  FOOTER_TEXT_COLOR: '#999999',
  HEADER_TEXT_COLOR: '#FBFBFD',
  DIVIDER_COLOR: '#848D93',
  LIGHT_BG_COLOR: '#FBFBFD',
  GRAY_BG_COLOR: '#F5F5F7',
  SECTION_TITLE: '#2E2E2E',
  SECTION_TEXT: '#2E2E2E',
  RED_LINE: '#D13B3B',
  RED_TITLE: '#D13B3B',
  BG_DOMAIN_CARD: '#dcdcde',
  BG_CIRCLE: '#d9d9d9',
  BORDER_CARD: '#999999',
  GRAY_ICON: '#999999',
  ARROW_BTN: '#cccccc',
  ARROW_BTN_HOVER: '#aaaaaa',
  BG_NEXT_MOVES: '#F4F4F4',
  BORDER_NEXT_MOVES: '#EF4557',
  BG_PLACEHOLDER: '#ccc',
  FEATURE_INACTIVE: '#898282',
  STEP: '#dcdcdd',
  DOMAIN_NAME: '#959595',
  INTRO_TEXT_COLOR: '#999999',
  INTRO_CARD_BACKGROUND: '#E8E8E8',
  INDUSTRIES_BTN: '#2E2E2E',
  STEP_GRAY_BORDER: '#C4C4C4',
  STEP_RED_BORDER: '#C63031',
  STEP_ACTIVE_COLOR: '#2E2E2E',
  STEP_INACTIVE_COLOR: '#717171',
  DEV_BACKGROUND: '#d9d9d9',
  CARD_TAGS_COLOR: '#959595',
  ACTIVE_ARROW: '#2E2E2E',
  INACTIVE_ARROW: '#BEBEBF',
  PROJECT_ARROW_BACKGROUND: '#D0D2D4',
  PROJECT_TEXT_BACKGROUND: '#E8E8E8',
  RED_BORDER: '#EF4557',
  ACTIVE_ITEM: '#E8E8E8',
  TAG_BORDER: '#0000001A',
  RED_PRESSED: '#BE2222',
  ABOUT_US_CTA_BG: '#252525',
};
